// Soft UI Dashboard PRO React Base Styles
import colors from "assets/theme/base/colors";
import typography from "assets/theme/base/typography";
import borders from "assets/theme/base/borders";

// Soft UI Dashboard PRO helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const { dark, white, grey, inputColors } = colors;
const { size, fontWeightRegular } = typography;
const { borderWidth, borderRadius } = borders;

const inputBase = {
  styleOverrides: {
    root: ({ theme, ownerState }) => {
      const isDarkMode = theme.palette.mode === "dark";
      const isDisabled = Boolean(ownerState?.disabled);
      const disabledBackground = isDarkMode ? "var(--input-bg-color)" : grey[200];
      const disabledBorderColor = isDarkMode ? "var(--input-border-color)" : inputColors.borderColor.main;

      return {
        display: "grid !important",
        placeItems: "center !important",
        width: "100% !important",
        height: "auto !important",
        padding: `${pxToRem(8)} ${pxToRem(12)}`,
        fontSize: `${size.sm} !important`,
        fontWeight: `${fontWeightRegular} !important`,
        lineHeight: "1.5 !important",
        color: `${grey[700]} !important`,
        backgroundColor: isDisabled ? `${disabledBackground} !important` : undefined,
        backgroundClip: "padding-box !important",
        border: `${borderWidth[1]} solid ${isDisabled ? disabledBorderColor : inputColors.borderColor.main}`,
        appearance: "none !important",
        borderRadius: borderRadius.md,
        transition: "box-shadow 150ms ease, border-color 150ms ease, padding 150ms ease !important",
      };
    },

    input: ({ theme, ownerState }) => {
      const isDarkMode = theme.palette.mode === "dark";
      const isDisabled = Boolean(ownerState?.disabled);
      const disabledTextColor = isDarkMode ? grey[500] : grey[600];

      return {
        width: "100% !important",
        height: `${pxToRem(22)}`,
        padding: "0 !important",
        color: isDisabled ? `${disabledTextColor} !important` : undefined,
        WebkitTextFillColor: isDisabled ? `${disabledTextColor} !important` : undefined,

        "&::-webkit-input-placeholder": {
          color: `${dark.main} !important`,
        },
      };
    },
  },
};

export default inputBase;
